import { render, staticRenderFns } from "./Palletspu.vue?vue&type=template&id=5a6c6ceb&scoped=true"
import script from "./Palletspu.vue?vue&type=script&lang=js"
export * from "./Palletspu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c6ceb",
  null
  
)

export default component.exports